import { MedicalServiceWithPractitionersSimpleQuery } from '@dreryk/egabinet-private-medical-service-frontend-api';

import { refetchCqrsQuery } from '@dreryk/command-query-react-common';

export const useRefetchMedicalServices = (): VoidFunction => {
   return () => {
      refetchCqrsQuery(MedicalServiceWithPractitionersSimpleQuery);
   };
};
